<div class="style-guide-list-components">
  <div class="content" *ngIf="isExpanded$ | async as isExpanded" [ngClass]="{ active: isExpanded === 'true' }">
    <button class="btn-link button-toggle" (click)="toggleMenu()">
      <span class="material-symbols-outlined">
        @if (isExpanded === 'true') {
          arrow_back_ios
        } @else {
          arrow_forward_ios
        }
      </span>
    </button>

    <ul>
      <li *ngFor="let component of components">
        <button class="btn-link" (click)="scrollToSection(component.id)">{{ component.label }}</button>
      </li>
    </ul>
  </div>
</div>
